
//let clientID = 'fdd33b48-1fc3-41d2-b8ff-1f2345b8034d';  //PPT Client Id
let clientID = '1d6ea848-a9f7-4261-8a10-d6070bacbc7f';  //GPT Client Id
let instance = 'https://login.microsoftonline.com/';
let tenant = 'rockco.onmicrosoft.com';
let appInsightKey = 'b1286596-73cc-479c-8cd6-8790974ced0f';
//let scope = 'https://rcmptool/User.Read'; //PPT Scope
let scope = 'https://rcmgpt-nonprod/User.Read'; //GPT Scope
let apiBaseUrl = 'https://api.dev.rockco.com/proposal/api/';
//let cosmosSearchAPI = 'https://api.qa.rockco.com/search/';   //QA
let cosmosSearchAPI = 'https://api.dev.rockco.com/search/';
let pmAPI = 'https://api.dev.rockco.com/pm/api/';
let ipProfileAPI = 'https://api.dev.rockco.com/ipprofileapi/api/';   
let goalsProfileAPI = 'https://api.dev.rockco.com/goalsprofileapi/api/'
let invAPI = 'https://api.dev.rockco.com/investments/api/';
let isAppMonitoringEnabled = false;  //Monitoring is disabled on local but enabled on Dev,Qa and Prod servers
let isPPTEnabled = 'N'; //PPT is enabled or disabled
let isNewFeatureEnabled = 'Y'; //New features are by default always disabled in Prod and QA and Dev but enabled on local
let isLocalMode = false;
let logChartSeries = true;
let eaUIURL = "https://ea.dev.rockco.com/ea/";

let scopes = [];

let config: any = (window as any).config ? atob((window as any).config) : null;

if (config) {
    config = JSON.parse(config);
    clientID = config.RCMPPTAADPClientId;
    instance = config.RCMPPTAADPInstance;
    tenant = config.RCMPPTAADPTenantId;
    appInsightKey = config.APPINSIGHTS_INSTRUMENTATIONKEY;
    scope = config.RCMPPTAADScope;
    scopes = scope.split(",");
    apiBaseUrl = config.BaseAPIUrl;
    pmAPI = config.PMAPI;
    cosmosSearchAPI = config.COSMOSSearchAPI;
    invAPI = config.RCMINVAPI
    ipProfileAPI = config.RCMPPTPROFILEAPI;
    goalsProfileAPI = config.RCMGOALSPROFILEAPI;
    isAppMonitoringEnabled = true;
    isPPTEnabled = config.RCMPPTENABLED;
    isNewFeatureEnabled = config.RCMPPTNEWFEATURE; 
    eaUIURL = config.RCMPPTEAUIURL;
    logChartSeries = false;      
}
    
export class Constant {
    static config = {
        clientId: clientID,
        instance: instance,
        tenant: tenant,
        appInsightKey: appInsightKey,
        scope: scope,
        scopes: scope.split(','),
        autority: instance + tenant,
        apiBaseUrl:apiBaseUrl,
        cosmosSearchAPI: cosmosSearchAPI,
        ipProfileAPI: ipProfileAPI,        
        goalsProfileAPI: goalsProfileAPI,
        pmAPI:pmAPI,
        invAPI: invAPI,
        isAppMonitoringEnabled: isAppMonitoringEnabled,
        isPPTEnabled: isPPTEnabled,
        isNewFeatureEnabled: isNewFeatureEnabled,
        isLocalMode: isLocalMode,
        logChartSeries: logChartSeries,
        eaUIURL: eaUIURL

    };

    static routes = {
        home: 'home',
        plan: 'plan',
        poc: 'poc'      
    }   

    static AppMsg = {
        PPTPreview: 'Preview – Not ready for client delivery'
    }

    static getprotectedresourcemap = (() => {
        let _map = [];
        _map.push([apiBaseUrl, scope.split(',')]);
        return _map;
    });
    

    static searchQuery = {
        clientSearch: 'queryType=full&select=ClientAdvisorID,ClientAdvisor,ClientAdvisorTeam,LegalEntityName,LegalEntityID,legalEntityType,dateofBirth,ClientKPI,loginDetails,Account,externalAccounts,id,rid,householdId,householdName,householdList&$count=true&$top=5',
        //change top value in below query to get more clients (used on plan list)
        clientSearchMore: 'queryType=full&select=ClientAdvisorID,ClientAdvisor,ClientAdvisorTeam,LegalEntityName,LegalEntityID,legalEntityType,dateofBirth,ClientKPI,loginDetails,Account,externalAccounts,id,rid,householdId,householdName,householdList&$count=true&$top=10&$orderby=ClientKPI/AumTotal desc',
        clientSearchWithSearchText: 'queryType=full&searchFields=LegalEntityName&select=ClientAdvisorID,ClientAdvisor,ClientAdvisorTeam,LegalEntityName,LegalEntityID,legalEntityType,dateofBirth,ClientKPI,loginDetails,Account,externalAccounts,id,rid,householdId,householdName,householdList&$count=true&$top=5',
        accountSearch: 'queryType=full&select=ClientAdvisorID,ClientAdvisor,ClientAdvisorTeam,CustodyAccount,LegalEntityName,LegalEntityID,legalEntityType,dateofBirth,AccountKPIs,AccountNickname,accounttype,Shortname,CustodianType,CustodianName,registrationtype,id,rid,gfoCustodyAccount,registrationDesc,householdId,householdName&$count=true&$top=5',
        accountSearchWithSearchText: 'queryType=full&searchFields=CustodyAccount,LegalEntityName,AccountNickname,Shortname&select=ClientAdvisorID,ClientAdvisor,ClientAdvisorTeam,CustodyAccount,LegalEntityName,LegalEntityID,legalEntityType,dateofBirth,AccountKPIs,AccountNickname,accounttype,Shortname,CustodianType,CustodianName,registrationtype,id,rid,gfoCustodyAccount,registrationDesc,householdId,householdName&$count=true&$top=5',
        accountSearchIn: 'queryType=full&select=ClientAdvisorID,ClientAdvisor,ClientAdvisorTeam,CustodyAccount,LegalEntityName,LegalEntityID,legalEntityType,dateofBirth,AccountKPIs,AccountNickname,accounttype,Shortname,CustodianType,CustodianName,registrationtype,id,rid,gfoCustodyAccount,registrationDesc,taxstatus,positions,modelId,modelName,modelType,householdId,householdName&$orderby=CustodianType desc,AccountKPIs/AccountTotal desc'
    }

    static uri = {      
        securitymastersearch:`${invAPI}securitymaster/search`,
        securitysearchapi: `${invAPI}securitymaster/search`,
        modellist:`${pmAPI}Reference`,
        managedmodeldetails:`${pmAPI}Model/`,
        indsectorsapi:`${apiBaseUrl}reference/IndSectors`,
        taxonomyreferenceapi:`${apiBaseUrl}reference/taxonomy`,
        taxonomyhierarchyrefapi:`${apiBaseUrl}reference/Hierarchy`,        
        rollupapi:`${apiBaseUrl}rollup/rollup`,
        fianalysisapi: `${apiBaseUrl}Analytics/FIAnalysis`,
        historicalassetprojectionapi: `${apiBaseUrl}Analytics/HistoricalAssetProjection`,
        profilesave: `${ipProfileAPI}proposal/save`,
        profilelist: `${ipProfileAPI}proposal/list`,
        profileDetails: `${ipProfileAPI}proposal/details/`,
        profileDelete: `${ipProfileAPI}proposal/delete/`,
        rcmmmodellist: `${ipProfileAPI}RCMModel/list`,
        rcmmodeldetails: `${ipProfileAPI}RCMModel/details/`,
        rcmmodelsave: `${ipProfileAPI}RCMModel/save`,
        rcmmodeldelete: `${ipProfileAPI}RCMModel/delete/`,
        cosmosclientsearchapi: `${cosmosSearchAPI}clients`,       
        cosmosaccountsearchapi: `${cosmosSearchAPI}accounts`,
        cosmoshouseholdsearchapi: `${cosmosSearchAPI}households`,  
        profileTemplate: `${ipProfileAPI}Template/details/`,   //documents in UI project are templates in db
        profileLayout: `${ipProfileAPI}Layout/details/`,  //templates in UI project are layout in db
        profileTemplateList: `${ipProfileAPI}Template/list/`, 
        profileLayoutList: `${ipProfileAPI}Layout/list/` ,        
        goalanalysis: `${apiBaseUrl}analytics/goalanalysis/`,          
        planList: `${goalsProfileAPI}plan/list`,
        planSave: `${goalsProfileAPI}plan/save`,
        planDetails: `${goalsProfileAPI}plan/details/`, 
        planDelete: `${goalsProfileAPI}plan/delete/`,   
        removeClient: `${goalsProfileAPI}plan/removeclient/`,   
        defaultExpenseRefapi:`${apiBaseUrl}PlanningReference/DefaultExpense`,
        keyValueRefapi:`${apiBaseUrl}PlanningReference/KeyValue`,
        lifeExpectancyRefapi:`${apiBaseUrl}PlanningReference/LifeExpectancy`,
        accountRefapi:`${apiBaseUrl}PlanningReference/ActType`,
        eaList: `${goalsProfileAPI}ExternalAccounts/list/`,
        eaListByClientIds: `${goalsProfileAPI}ExternalAccounts/list/multiclient`,
        eanDetails: `${goalsProfileAPI}ExternalAccounts/`,
        eanDetailsEAIds: `${goalsProfileAPI}ExternalAccounts/multiid`,
        createEA: `${eaUIURL}:?cid=`,
        editEA: `${eaUIURL}`
    };
   

    static consoleLogStyle = {
        clearStyles: '',
        frameworkDocument:  'background: blue; color: white;',
        frameworkTemplate:  'background: blue; color: yellow;',
        frameworkComponentContainer: 'background: blue; color: aqua;',
        appContext: 'background: purple; color: white;',
        documentContext: 'background: green; color: white;',
        uiState: 'background: orange; color: white;',
        debug: 'background: red; color: white; font-size: 16px;'
    }

    static ErrorMsgs = {
        systemErrorMsg: "System Error...",
        analyticErrorMsg: "Goal Analysis Error...",
        durationErrorMsg: "DURATION END must be greater than DURATION START",                
        saveFailure: "System Error..."
    }

    static InfoMsgs = {
        saveSuccess: "Plan Updated..."        
    }

    static ToolTips = {
        buinessClientTooltip: "Selected client is business or trust entity. Please select individual client to create a plan."
    }

   

}
